import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-141d3d14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alerts"
};
const _hoisted_2 = {
  class: "alerts-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alerts-content-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-title"
}, "Alerting")])], -1));
const _hoisted_4 = {
  class: "alerts-content-middle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_alerts_content = _resolveComponent("alerts-content");
  const _component_alerts_sidebar = _resolveComponent("alerts-sidebar");
  const _component_alerts_details = _resolveComponent("alerts-details");
  const _component_b_overlay = _resolveComponent("b-overlay");
  return _openBlock(), _createBlock(_component_b_overlay, {
    show: $data.dataLoading,
    variant: "white",
    rounded: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_alerts_content, {
      items: _ctx.alerts,
      selectedId: $data.selectedId,
      selectedRowId: $data.selectedRowId,
      selectedLevel: $data.selectedLevel,
      expandData: $data.expandData,
      isColumn: $data.sidebarOpen || $data.detailsOpen,
      onSelect: $options.onToggleSelect,
      onSelectId: $options.onToggleId
    }, null, 8, ["items", "selectedId", "selectedRowId", "selectedLevel", "expandData", "isColumn", "onSelect", "onSelectId"])])]), _createVNode(_component_alerts_sidebar, {
      modelValue: $data.sidebarOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.sidebarOpen = $event),
      items: _ctx.alerts,
      selectedId: $data.selectedId,
      selectedRowId: $data.selectedRowId,
      selectedLevel: $data.selectedLevel,
      selectedType: $data.selectedType,
      onSelect: $options.onToggleId,
      onClose: $options.onSidebarClose,
      onExpand: $options.onExpand
    }, null, 8, ["modelValue", "items", "selectedId", "selectedRowId", "selectedLevel", "selectedType", "onSelect", "onClose", "onExpand"]), _createVNode(_component_alerts_details, {
      modelValue: $data.detailsOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.detailsOpen = $event),
      items: _ctx.alerts,
      selectedId: $data.selectedId,
      selectedType: $data.selectedType,
      onAssigneeChange: $options.onAssigneeChange,
      onStatusChange: $options.onStatusChange,
      onSelect: $options.onSelectId,
      onClose: $options.onDetailsClose
    }, null, 8, ["modelValue", "items", "selectedId", "selectedType", "onAssigneeChange", "onStatusChange", "onSelect", "onClose"])])]),
    _: 1
  }, 8, ["show"]);
}